export type StateType = {
  search: string;
  brands: string[];
  ranges: string[];
};
export type FilterKeyType = 'search' | 'brands' | 'ranges';

export type ActionType = {
  type: string;
  value?: any;
  filterKey?: FilterKeyType;
};

export const CHANGE_SEARCH = 'CHANGE_SEARCH';
export const RESET = 'RESET';
export const REMOVE = 'REMOVE';
export const ADD = 'ADD';

export const initialState = {
  search: '',
  brands: [],
  ranges: [],
};

const filterReducer = (
  state: StateType = initialState,
  action: { type: string; value?: any; filterKey?: FilterKeyType },
): StateType => {
  switch (action.type) {
    case CHANGE_SEARCH:
      return {
        ...state,
        search: action.value,
      };
    case ADD:
      if (!action.filterKey) {
        return state;
      }
      return {
        ...state,
        [action.filterKey]: action.value,
      };
    case REMOVE:
      if (!action.filterKey) {
        return state;
      }
      return {
        ...state,
        [action.filterKey]: state[
          action.filterKey as 'brands' | 'ranges'
        ].filter((keyword: string) => keyword !== action.value),
      };
    case RESET:
      return initialState;

    default:
      return state;
  }
};

export default filterReducer;
